"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _links = _interopRequireDefault(require("draft-plugins/lib/links"));

var _ContentPopoverEmptyState = _interopRequireDefault(require("../../../components/popover/ContentPopoverEmptyState"));

var KnowledgePopoverEmptyState = function KnowledgePopoverEmptyState(_ref) {
  var portalId = _ref.portalId;
  return _react.default.createElement(_ContentPopoverEmptyState.default, {
    portalId: portalId,
    image: "bulb",
    title: "draftPlugins.knowledgeArticlesPlugin.popover.emptyState.title",
    description: "draftPlugins.knowledgeArticlesPlugin.popover.emptyState.description",
    buttonLabel: "draftPlugins.knowledgeArticlesPlugin.manage",
    buttonLink: _links.default.getKnowledgeUrl(portalId)
  });
};

KnowledgePopoverEmptyState.propTypes = {
  portalId: _react.PropTypes.number.isRequired
};
var _default = KnowledgePopoverEmptyState;
exports.default = _default;
module.exports = exports.default;